import BaseModel from "./BaseModel";
import PlaceTouristRegion from "./PlaceTouristRegion";

export default class PlaceCountry extends BaseModel {
    private _id: number = -1;
    private _title: string = '';
    private _code: string = '';
    private _description: string = '';
    private _regions: Array<PlaceTouristRegion> = [];
    private _latitude: number = -1;
    private _longitude: number = -1;
    private _langtitle: { [k: string]: string } = {};
    private _langdescription: { [k: string]: string } = {};
    private _count_of_accommodations: number = -1;

    public fromObject(jsonObj: object): BaseModel {
        return super.fromObject(jsonObj, {
            regions: (item => {
                return (new PlaceTouristRegion()).fromObject(item);
            }),
        })
    }


    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get regions(): Array<PlaceTouristRegion> {
        return this._regions;
    }

    set regions(value: Array<PlaceTouristRegion>) {
        this._regions = value;
    }

    get latitude(): number {
        return this._latitude;
    }

    set latitude(value: number) {
        this._latitude = value;
    }

    get longitude(): number {
        return this._longitude;
    }

    set longitude(value: number) {
        this._longitude = value;
    }


    get code(): string {
        return this._code;
    }

    set code(value: string) {
        this._code = value;
    }


    get count_of_accommodations(): number {
        return this._count_of_accommodations;
    }

    set count_of_accommodations(value: number) {
        this._count_of_accommodations = value;
    }

    get langdescription(): { [p: string]: string } {
        return this._langdescription;
    }

    set langdescription(value: { [p: string]: string }) {
        this._langdescription = value;
    }

    get langtitle(): { [p: string]: string } {
        return this._langtitle;
    }

    set langtitle(value: { [p: string]: string }) {
        this._langtitle = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }
}
